import { render } from "./price.vue?vue&type=template&id=38bb9b80"
import script from "./price.vue?vue&type=script&lang=js"
export * from "./price.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/components/form/input-only/price.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38bb9b80"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38bb9b80', __exports__)) {
    console.log('reload')
    api.reload('38bb9b80', __exports__)
  }
  
  module.hot.accept("./price.vue?vue&type=template&id=38bb9b80", () => {
    console.log('re-render')
    api.rerender('38bb9b80', render)
  })

}


export default __exports__